import { css } from '@emotion/react';

export const loader = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const player = css`
  width: 100%;
  height: 80vh;
  border: none;
`;
